import React, {
  Children,
  cloneElement,
  isValidElement,
  ReactNode,
} from 'react';
import {
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  DialogContent,
  DialogContentText,
} from '@mui/material';
import { create } from 'react-modal-promise';

type ConfirmDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  contentText?: string;
  contentHidden?: boolean;
  drillHandlers?: boolean;
  onResolve?: (isConfirmed: boolean) => void;
  confirmText?: string;
  cancelText?: string;
};

const DEFAULT_TITLE = 'Отменить изменения?';
const DEFAULT_CONTENT_TEXT =
  'Вы действительно хотите отменить все изменения и выйти? Введенные данные будут утеряны';

const ConfirmDialog = (props: ConfirmDialogProps) => {
  const {
    isOpen,
    onClose,
    onConfirm,
    onResolve,
    title,
    contentText,
    contentHidden,
    drillHandlers,
    confirmText,
    cancelText,
  } = props;
  const handleClose = () => (onResolve ? onResolve(false) : onClose());
  const handleConfirm = () => (onResolve ? onResolve(true) : onConfirm());

  const contentTextWithProps =
    typeof contentText !== 'string' && drillHandlers
      ? Children.map<ReactNode, ReactNode>(contentText, (child) => {
          if (isValidElement(child)) {
            return cloneElement(child as React.ReactElement, {
              handleClose,
              handleConfirm,
              onResolve,
            });
          }
          return child;
        })
      : contentText;

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ py: 2, overflowWrap: 'anywhere' }}>
        {title || DEFAULT_TITLE}
      </DialogTitle>

      {!contentHidden &&
        (drillHandlers ? (
          contentTextWithProps
        ) : (
          <DialogContent sx={{ py: 1 }}>
            <DialogContentText sx={{ color: 'initial' }}>
              {contentTextWithProps || DEFAULT_CONTENT_TEXT}
            </DialogContentText>
          </DialogContent>
        ))}

      {!drillHandlers && (
        <DialogActions sx={{ px: 3, py: 1 }}>
          <Button variant="text" onClick={handleClose} color="primary">
            {cancelText || 'Отмена'}
          </Button>
          <Button
            variant="text"
            onClick={handleConfirm}
            color="accent"
            sx={{ minWidth: 'unset' }}
          >
            {confirmText || 'Да'}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default ConfirmDialog;
export const ConfirmDialogModal = create<any, any, any>(ConfirmDialog);
